let _instance;
/**
 * @param {HTMLElement} header
 * @param {{elem: HTMLElement|null, toggleShow: (show?: boolean)=>void}} announcement
 */
export function initHeaderShrinking(header, announcement) {
  if (_instance && _instance.init) {
    return _instance;
  }

  const breakpoints = {
    "md-min": () => {
      init();
    },
    "sm-max": () => {
      destroy();
    },
  };

  function headerScroll() {
    const scrolled = window.scrollY >= 50;
    header.classList.toggle("header_small", scrolled);
    announcement.toggleShow(!scrolled);
  }

  function init() {
    window.addEventListener("scroll", headerScroll);
  }

  function destroy() {
    window.removeEventListener("scroll", headerScroll);
  }

  _instance = {
    init,
    destroy,
    breakpoints,
  };

  return _instance;
}
